export default __webpack_public_path__ + "static/media/pants-short-2.28c477b1.png";